import React from 'react';
import { useLocation } from 'react-router-dom';

const Resume: React.FC = (): JSX.Element => {
  const location = useLocation();
  
  // Show nothing on the homepage (just particle background)
  if (location.pathname === '/') {
    return null;
  }
  
  // Show content only when explicitly on /resume
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body p-0">
              <div style={{ height: '90vh', width: '100%' }}>
                <iframe
                  src="/assets/kevin-xu-2025-resume.pdf"
                  width="100%"
                  height="100%"
                  style={{ border: 'none' }}
                  title="Kevin Xu Resume"
                >
                  <p>
                    Your browser does not support PDFs. 
                    <a href="/assets/kevin-xu-2025-resume.pdf" target="_blank" rel="noopener noreferrer">
                      Download the PDF instead
                    </a>
                  </p>
                </iframe>
              </div>
            </div>
            <div className="card-footer text-center text-muted">
              <small>
                Having trouble viewing? 
                <a href="/assets/kevin-xu-2025-resume.pdf" target="_blank" rel="noopener noreferrer" className="ml-1">
                  Download PDF
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
